import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { LoadingMaskService } from '../../../shared/loading-mask/loading-mask.service';
import { Press, PressService } from './press.service';
import { CommonFiltersResolve } from '../filters/common-filters-resolve';
import { ActiveFiltersService } from '../filters/active-filters.service';

@Injectable()
export class PressResolve extends CommonFiltersResolve implements Resolve<Press[]> {
	constructor(private service: PressService,
	            private activeFiltersService: ActiveFiltersService,
	            private mask: LoadingMaskService) {
		super(activeFiltersService);
	}

	resolve(route: ActivatedRouteSnapshot): Promise<Press[]> {
		this.mask.addLoading();
		let filters: any = this.initActiveFiltersFromURLParams(route);
		return this.service.getPress(filters)
			.then((press: Press[]) => {
				this.mask.removeLoading();
				return press;
			});
	}
}
